module.exports = {
      id: "app-recommend-bg-usage",
      viewBox: "0 0 630 816",
      url: __webpack_public_path__ + "images/js_src_vue/page_adguard_landing/sprite.dab809d9.svg#app-recommend-bg-usage",
      toString: function () {
        return this.url;
      }
    }